// extracted by mini-css-extract-plugin
export var alt = "SearchMap-module--alt--13d11";
export var container = "SearchMap-module--container--5dfc9";
export var desktopOnly = "SearchMap-module--desktopOnly--a5dbd";
export var hotelEmpty = "SearchMap-module--hotelEmpty--2794b";
export var main = "SearchMap-module--main--1a6bf";
export var mobileOnly = "SearchMap-module--mobileOnly--c0489";
export var styledMap = "SearchMap-module--styledMap--5476f";
export var textLeft = "SearchMap-module--textLeft--31151";
export var visuallyHidden = "SearchMap-module--visuallyHidden--18905";